/**
 * Format a number string for display:
 * - Add commas to integer part
 * - Preserve decimal part if any
 * - Prefix with $
 */
export function formatCurrencyInput(val?: string | number): string {
  if (val === undefined || val === null || val === '') return '';
  const str = String(val);
  const [intPart, decPart] = str.split('.');
  const intWithCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart !== undefined
    ? `$ ${intWithCommas}.${decPart}`
    : `$ ${intWithCommas}`;
}

/**
 * Parse a formatted currency string back into a number:
 * - Remove $, commas, spaces
 * - Allow only one decimal point
 */
export function parseCurrencyInput(val?: string): number {
  if (!val) return 0;
  const cleaned = val.replace(/[^0-9.]/g, '');
  const parts = cleaned.split('.');
  const normalized =
    parts.length > 1 ? `${parts[0]}.${parts.slice(1).join('')}` : parts[0];
  return normalized ? Number(normalized) : 0;
}
